import { formatCurrency, pn } from "@compass/core";
import { DevExpressReport, renderReportColumn, renderReportSummary } from "components";
import { MatchReportAllPartners, ReportPropertyBase } from "generated/openApi";

export const AllPartners = (props: { report: MatchReportAllPartners }) => {
  return (
    <DevExpressReport
      dataSource={props.report.reportResultRows}
      exportFormats={["pdf", "excel", "csv"]}
      onExporting={() => {
        return {
          header: "All Partners Report",
          filename: "AllPartners",

          tenantName: props.report.tenantName,
          infoTuples: [
            ["Date From", props.report.dateFrom ? new Date(props.report.dateFrom).toDateString() : undefined],
            ["Date To", props.report.dateTo ? new Date(props.report.dateTo).toDateString() : undefined],
            ["Status", props.report.reviewName],
            ["Grand Total", formatCurrency(props.report.grandTotal)],
          ],
        };
      }}
    >
      {props.report.reportProperties?.map((property) =>
        renderReportColumn({
          property: property,
          propertyKey: pn<ReportPropertyBase>("propertyName"),
        })
      )}

      {renderReportSummary({
        properties: props.report.reportProperties,
        propertyKey: pn<ReportPropertyBase>("propertyName"),
      })}
    </DevExpressReport>
  );
};
